import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagWS = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M50 25c0 13.807-11.193 25-25 25S0 38.807 0 25L25 0c13.807 0 25 11.193 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M25 25V0C11.193 0 0 11.193 0 25h25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m20.025 16.304.404 1.246h1.31l-1.06.77.405 1.245-1.06-.77-1.059.77.405-1.245-1.06-.77h1.31l.405-1.246ZM13.446 6.521l.675 2.076h2.182L14.537 9.88l.675 2.076-1.766-1.283-1.766 1.283.675-2.076-1.766-1.283h2.182l.675-2.076ZM19.97 8.696l.674 2.076h2.183l-1.766 1.283.674 2.075-1.765-1.283-1.766 1.284.674-2.076-1.766-1.283h2.183l.675-2.076ZM14.815 17.39l.674 2.076h2.183l-1.766 1.283.675 2.076-1.766-1.283-1.766 1.283.674-2.076-1.766-1.283h2.183l.675-2.076ZM9.1 11.956l.674 2.077h2.183l-1.766 1.282.674 2.076L9.1 16.108l-1.766 1.283.675-2.076-1.766-1.282h2.183l.674-2.077Z"
}));
FlagWS.displayName = 'FlagWS';
export default withFlagWrapper(FlagWS);
//# sourceMappingURL=index.js.map